<template>
  <a-spin :spinning="spinning">
    <template #indicator>
      <Loading></Loading>
    </template>
    <div class="pc" v-if="orderDetails">
      <div class="pc-content-info">
        <div class="title-lang">
          <div>
            <template v-if="!orderDetails?.checkoutLogo">
              <div class="title">{{ $t('message.subscribe.yourSubscribe') }}</div>
              <div class="description">{{ $t('message.subscribe.unsubscribeTip') }}</div>
            </template>
            <img v-else class="title-logo" :src="orderDetails?.checkoutLogo" alt="LOGO" />
          </div>
          <Lang></Lang>
        </div>

        <div class="order-info">
          <div class="products Subscribe">
            <div class="item">
              <span class="text amount">{{ orderDetails.tradeAmount }} {{ orderDetails.tradeCurrency }}</span>
              <span class="text month">{{ getSubscriptionCycleText(orderDetails.billingCycle) }}</span>
            </div>
            <div
              class="tip"
              v-html="
                $t('message.subscribe.renewTip', {
                  date: getSubscriptionCycleText(orderDetails.billingCycle),
                  amount: orderDetails.tradeAmount,
                  currency: orderDetails.tradeCurrency
                })
              "
            ></div>
          </div>
          <div class="amount-info">
            <div class="item">
              <span class="label">{{ $t('message.checkout.product') }}</span>
              <span class="text" :title="orderDetails.productName">{{ orderDetails.productName }}</span>
            </div>
            <div class="item">
              <span class="label">{{ $t('message.checkout.subscribeType') }}</span>
              <span class="text">{{ getSubscriptionTypeText(orderDetails.subscriptionType) }}</span>
            </div>
            <div class="item">
              <span class="label">{{ $t('message.checkout.renewCycle') }}</span>
              <span class="text">{{ getSubscriptionCycleText(orderDetails.billingCycle) }}</span>
            </div>
            <div class="item">
              <span class="label">{{ $t('message.checkout.renewAmount') }}</span>
              <span class="text">{{ orderDetails.tradeAmount }} {{ orderDetails.tradeCurrency }}</span>
            </div>
          </div>
        </div>

        <div>
          <a-button class="button" type="primary" size="large" @click="handleUnsubscribe">
            <span>{{ $t('message.subscribe.unsubscribe') }}</span>
          </a-button>
          <div
            class="delete-tips"
            v-html="$t('message.subscribe.unsubscribeTipTwo', { date: orderDetails.finalDueDate })"
          ></div>
          <!-- <a-button @click="openProtocol" class="return-link" type="link">
            {{ $t('message.subscribe.autoRenew') }}
          </a-button> -->
        </div>
      </div>
    </div>

    <!-- 协议组件 -->
    <!-- <Protocol v-model="protocolVisible" /> -->

    <!-- 取消订阅确认模态框 -->
    <a-modal
      v-model="unsubscribeModalVisible"
      :title="null"
      :footer="null"
      @cancel="handleModalCancel"
      @close="handleModalCancel"
      width="380px"
      class="unsubscribe-modal"
      style="border-radius: 20px; overflow: hidden"
    >
      <div style="padding: 32px 8px">
        <!-- 标题和描述 -->
        <div style="text-align: center; margin-bottom: 24px">
          <div style="font-size: 20px; font-weight: 600; color: #222; margin-bottom: 8px">
            {{ $t('message.subscribe.emailVerifyTip') }}
          </div>
          <div style="color: #666; font-size: 14px">{{ $t('message.subscribe.sendEmailTip') }}</div>
        </div>

        <!-- 邮箱展示 -->
        <div
          style="
            background: #f7f9fc;
            border-radius: 12px;
            padding: 14px 16px;
            text-align: center;
            margin-bottom: 20px;
            font-size: 15px;
            color: #333;
          "
        >
          {{ userEmail }}
        </div>

        <!-- 获取验证码按钮 -->
        <div style="display: flex; gap: 10px; margin-bottom: 20px">
          <a-button
            type="primary"
            :disabled="codeCountdown > 0"
            @click="getVerificationCode"
            class="theme-primary-btn theme-primary-btn--send"
          >
            {{
              codeCountdown > 0
                ? $t('message.subscribe.sendCodeTip', { code: codeCountdown })
                : $t('message.subscribe.sendEmailTip')
            }}
          </a-button>
        </div>

        <!-- 6位验证码输入 -->
        <div style="display: flex; flex-direction: column; align-items: center">
          <div style="display: flex; gap: 8px; justify-content: center; margin-bottom: 16px">
            <input
              v-for="i in 6"
              :key="i"
              type="text"
              maxlength="1"
              :data-index="i-1"
              style="
                width: 46px;
                height: 46px;
                text-align: center;
                font-size: 18px;
                border: 1px solid #e0e0e0;
                border-radius: 12px;
                outline: none;
                transition: all 0.2s;
              "
              @input="handleCodeInput($event, i)"
              @keydown="handleCodeKeydown($event, i)"
            />
          </div>
          <div v-if="codeError" style="color: #ff4d4f; font-size: 14px; margin-bottom: 20px">
            <div v-if="numberError">{{ $t('message.subscribe.inputNumberTip') }}</div>
            <div v-else>{{ $t('message.subscribe.inputCodeTip') }}</div>
          </div>
        </div>

        <!-- 底部按钮组 -->
        <div style="display: flex; gap: 12px">
          <a-button
            @click="handleModalCancel"
            style="flex: 1; height: 48px; border-radius: 14px; background: #f1f3f5; color: #555; border: none"
          >
            {{ $t('message.common.cancel') }}
          </a-button>
          <a-button
            type="primary"
            @click="confirmUnsubscribe"
            class="theme-primary-btn theme-primary-btn--confirm"
          >
            {{ $t('message.common.confirm') }}
          </a-button>
        </div>
      </div>
    </a-modal>
  </a-spin>
</template>
<script>
import { mapGetters } from 'vuex'
import Loading from '@/components/loading'
import Lang from '@/components/lang/index.vue'
import Protocol from '@/components/protocol/index.vue'
import { initSecondDisplay } from '@/views/checkout/tools'
import { saveExecuteTime } from '@/views/checkout/tools/collect'
import { unsubscribeSendEmail, unsubscribe } from '@/views/subscribe/api/index'

export default {
  components: {
    Loading,
    Lang,
    Protocol
  },
  props: {
    order: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(['app'])
  },
  data() {
    return {
      spinning: false,
      protocolVisible: false,
      unsubscribeModalVisible: false,
      userEmail: '', // 这里需要从 orderDetails 或接口获取
      verificationCode: '',
      codeCountdown: 0,
      codeError: false,
      numberError: false,
      orderDetails: this.$props.order,
      orderId: this.$route.params.id
    }
  },
  mounted() {
    saveExecuteTime('startTime', window.initPage)
    saveExecuteTime('completedTime')
    
    // 添加粘贴事件监听
    document.addEventListener('paste', (e) => {
      const modal = document.querySelector('.unsubscribe-modal');
      if (!modal) return;
      
      e.preventDefault();
      const pasteText = (e.clipboardData || window.clipboardData).getData('text').trim();
      if (!pasteText) return;

      // 验证粘贴内容是否全部都是数字
      if (!/^\d+$/.test(pasteText)) {
        this.numberError = true;
        this.codeError = true;
        return;
      }

      const inputs = document.querySelectorAll('.unsubscribe-modal input[type="text"]');
      const codeArr = pasteText.split('');
      inputs.forEach((input, i) => {
        if (codeArr[i]) {
          input.value = codeArr[i];
        }
      });
      
      // 更新 verificationCode
      this.updateVerificationCode();
      
      // 清除错误提示
      this.codeError = false;
      this.numberError = false;
      
      // 粘贴完聚焦最后一个有值的框
      const lastIndex = Math.min(codeArr.length, inputs.length) - 1;
      if (inputs[lastIndex]) {
        inputs[lastIndex].focus();
      }
    });
  },
  methods: {
    initSecondDisplay,
    setCountdown(countdown) {
      this.countdown = countdown
    },
    openProtocol(event) {
      event.preventDefault()
      this.protocolVisible = true
    },
    getSubscriptionCycleText(cycle) {
      const cycleMap = {
        '0': this.$t('message.subscribe.weekly'),
        '1': this.$t('message.subscribe.monthly'),
        '2': this.$t('message.subscribe.quarterly'),
        '3': this.$t('message.subscribe.semiAnnually'),
        '4': this.$t('message.subscribe.annually'),
        '5': this.$t('message.subscribe.daily'),
        '6': this.$t('message.subscribe.eachCalendarMonth'),
      }
      return cycleMap[cycle] || cycle
    },
    getSubscriptionTypeText(type) {
      const typeMap = {
        '0': this.$t('message.subscribe.regularRenewal'),
        '1': this.$t('message.subscribe.oneTime')
      }
      return typeMap[type] || type
    },
    handleUnsubscribe() {
      // 打开取消订阅确认模态框
      this.unsubscribeModalVisible = true
      // 这里可以从 orderDetails 或接口获取用户邮箱
      this.userEmail = this.orderDetails?.email
    },
    getVerificationCode() {
      unsubscribeSendEmail(this.orderId).then((res) => {
        if (+res.status === 200) {
          this.$message.success(this.$t('message.subscribe.sendSuccessTip'))
        } else {
          this.$message.error(this.$t('message.subscribe.sendErrorTip'))
        }
      })
      // 开始倒计时
      this.codeCountdown = 60
      const timer = setInterval(() => {
        this.codeCountdown--
        if (this.codeCountdown <= 0) {
          clearInterval(timer)
        }
      }, 1000)
    },
    confirmUnsubscribe() {
      // 先更新 verificationCode
      this.updateVerificationCode()
      
      // 验证验证码
      if (!this.verificationCode || this.verificationCode.length !== 6) {
        // 长度不足6位
        this.numberError = false
        this.codeError = true
        return
      } else if (!/^\d{6}$/.test(this.verificationCode)) {
        // 包含非数字
        this.numberError = true
        this.codeError = true
        return
      }
      
      unsubscribe({
        planUuid: this.orderId,
        verifyCode: this.verificationCode
      }).then((res) => {
        if (+res.status === 200) {
          this.$message.success(this.$t('message.subscribe.unsubscribeSuccessTip'))
          this.unsubscribeModalVisible = false
          this.$router.push({
            name: 'SubscribeFailed',
            params: { id: this.orderId }
          })
        } else {
          this.$message.error(this.$t('message.subscribe.unsubscribeErrorTip'))
        }
      })
    },
    handleModalCancel() {
      this.unsubscribeModalVisible = false
      // 清空验证码
      this.verificationCode = ''
      this.codeError = false
      this.numberError = false
      // 清空所有输入框的值
      setTimeout(() => {
        const inputs = document.querySelectorAll('.unsubscribe-modal input[type="text"]')
        inputs.forEach(input => {
          input.value = ''
        })
      }, 0)
    },
    handleCodeInput(event, index) {
      // 清除错误提示
      this.codeError = false
      this.numberError = false

      // 只允许输入数字
      const originalValue = event.target.value
      const value = originalValue.replace(/[^0-9]/g, '')
      
      // 如果输入了非数字，显示错误提示
      if (originalValue !== value) {
        this.numberError = true
        this.codeError = true
      }
      
      event.target.value = value

      // 更新 verificationCode
      this.updateVerificationCode()

      // 自动聚焦到下一个输入框
      if (value && index < 6) {
        const nextInput = event.target.nextElementSibling
        if (nextInput) {
          nextInput.focus()
        }
      }
    },
    handleCodeKeydown(event, index) {
      const currentIndex = Number(event.target.dataset.index);
      
      // 按下删除键（Backspace）
      if (event.key === 'Backspace') {
        // 如果当前输入框有内容：清空内容 + 保持聚焦当前框
        if (event.target.value) {
          event.target.value = '';
          event.preventDefault();
          // 更新 verificationCode
          this.updateVerificationCode();
          return;
        }
        
        // 如果当前输入框为空：跳到上一个输入框
        if (currentIndex > 0) {
          const prevInput = event.target.previousElementSibling;
          if (prevInput) {
            prevInput.focus();
          }
        }
      }
    },
    updateVerificationCode() {
      // 遍历所有输入框，收集值
      const codeArray = Array(6).fill('')
      const inputs = document.querySelectorAll('.unsubscribe-modal input[type="text"]')
      inputs.forEach((input, i) => {
        codeArray[i] = input.value || ''
      })
      this.verificationCode = codeArray.join('')
    }
  }
}
</script>
<style lang="less" scoped>
@import '~@/styles/common.less';
@import '~@/views/checkout/styles/index.less';
@import '~@/styles/custom.less';

.pc {
  .theme-primary-btn {
    flex: 1;
    background: var(--color-primary) !important;
    border: none !important;
    color: #fff !important;

    &--send {
      height: 46px;
      border-radius: 12px;
    }

    &--confirm {
      height: 48px;
      border-radius: 14px;
    }

    &:hover,
    &:focus {
      background: var(--color-primary-hover) !important;
    }

    &:active {
      background: var(--color-primary-active) !important;
    }
  }

  display: flex;
  justify-content: center;
  max-width: 900px;
  margin: 0 auto;
  padding: 67px 20px 0;
  flex-wrap: wrap;

  .warn-tips {
    color: @warn-color;
    margin-top: -10px;
    margin-bottom: 15px;
  }

  .pc-content-info {
    background-color: @white;
    width: 100%;
    max-width: 540px;
    padding: 35px 40px;

    .title {
      #Font.heavy();
      font-size: 20px;
      line-height: 27px;
    }

    .description {
      font-size: 14px;
      line-height: 19px;
      margin-top: 10px;
      padding: 4px 6px;
    }

    .title-lang {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      margin-bottom: 50px;
    }

    .title-logo {
      max-width: 420px;
      max-height: 60px;
      object-fit: cover;
    }

    @media screen and (max-width: 900px) {
      padding: 40px 15px;

      .title {
        font-size: 18px;
        line-height: 24px;
      }

      .description {
        font-size: 13px;
        line-height: 18px;
        padding: 4px 6px;
      }

      .title-lang {
        margin-bottom: 30px;
      }

      .title-logo {
        max-width: 200px;
        max-height: 50px;
      }
    }

    .order-info {
      margin-top: 30px;

      .products {
        background: @checkout-bg;
        padding: 12px;

        .label {
          #Font.regular();
          font-size: 14px;
          line-height: 19px;
        }

        .content {
          #Font.heavy();
          font-size: 14px;
          line-height: 19px;
        }

        .products-list {
          margin-top: 15px;

          .products-item {
            #Font.regular();
            font-size: 14px;
            line-height: 19px;
          }
        }
      }
      .Subscribe {
        padding: 18px 12px 33px;
        margin-bottom: 20px;
        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 0;
          margin-bottom: 15px;

          .text {
            #Font.heavy();
            font-size: 14px;
            line-height: 19px;

            &.amount {
              font-size: 18px;
              line-height: 25px;
              color: @checkout-hight-text-color;
            }

            &.month {
              font-size: 18px;
              line-height: 25px;
            }
          }
        }
      }
      .amount-info {
        padding: 18px 12px 33px;
        margin-bottom: 20px;
        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 9px 0;

          .label {
            #Font.regular();
            font-size: 14px;
            line-height: 19px;
          }

          .text {
            #Font.heavy();
            font-size: 14px;
            line-height: 19px;
            max-width: 60%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;

            &.amount {
              font-size: 18px;
              line-height: 25px;
              color: @checkout-hight-text-color;
              max-width: 60%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }

      .countdown {
        padding: 0 12px;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 25px;

        .tip {
          #Font.regular();
          font-size: 14px;
          line-height: 19px;
        }

        .time {
          background: @checkout-bg;
          width: 75px;
          min-width: 75px;
          height: 34px;
          line-height: 34px;
          #Font.heavy();
          font-size: 14px;
          text-align: center;
          white-space: nowrap;
          margin-top: 4px;
        }
      }
    }
  }

  .button {
    width: 100%;
    #Font.heavy();
    .pay-button();
    background-color: @checkout-hight-text-color;
  }
  .delete-tips {
    text-align: center;
    margin: 10px 0;
    color: #8c8c8c;
  }
  .return-link {
    width: 100%;
    padding: 0;
    #Font.regular();
    font-size: 14px;
    margin-top: 20px;
  }

  @media screen and (max-width: 900px) {
    padding: 45px 15px;

    .pc-content-info {
      .order-info {
        margin-top: 20px;

        .Subscribe {
          padding: 12px 10px 20px;
          margin-bottom: 15px;

          .item {
            padding: 12px 0;
            margin-bottom: 10px;

            .text {
              font-size: 13px;
              line-height: 18px;

              &.amount,
              &.month {
                font-size: 16px;
                line-height: 22px;
              }
            }
          }
        }

        .amount-info {
          padding: 12px 10px 20px;
          margin-bottom: 15px;

          .item {
            padding: 8px 0;

            .label {
              font-size: 13px;
              line-height: 18px;
            }

            .text {
              font-size: 13px;
              line-height: 18px;

              &.amount {
                font-size: 16px;
                line-height: 22px;
              }
            }
          }
        }
      }
    }

    .button {
      font-size: 16px;
    }

    .delete-tips {
      font-size: 12px;
      margin: 8px 0;
    }

    .return-link {
      font-size: 13px;
      margin-top: 15px;
    }
  }
}
</style>
